import { render } from "./App.vue?vue&type=template&id=4821c2eb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4821c2eb&lang=css"

import exportComponent from "D:\\projects\\sales-workbench-front1\\sales-workbench-front\\sales-workbench-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__